<!-- Filters + Upload Button -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12">
      <div nxLayout="grid" class="nx-margin-top-s">
        <div nxRow>
          <div nxCol="2">
            <nx-formfield nxLabel="Status">
              <nx-dropdown [(nxValue)]="statusFilter" (selectionChange)="pageNumber=1; getInvoiceList()">
                <nx-dropdown-item nxValue="All">All</nx-dropdown-item>
                <nx-dropdown-item nxValue="Submitted">Submitted</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Accepted">Invoice Accepted</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Rejected">Invoice Rejected</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Under Process">Invoice Under Process</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Paid">Invoice Paid</nx-dropdown-item>
              </nx-dropdown>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Start Date">
              <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="startDate" />
              <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #startDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="End Date">
              <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="endDate" />
              <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #endDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="3">
            <nx-formfield>
              <input nxInput placeholder="Search..." [(ngModel)]="searchTerm" type="search" />
              <span nxFormfieldPrefix><nx-icon name="search" size="s"></nx-icon></span>
              <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm=''; getInvoiceList()">
                <nx-icon name="close" size="s"></nx-icon>
              </span>
            </nx-formfield>
          </div>

          <div nxCol="3" class="nx-margin-top-2xs" style="display:flex; gap:8px; align-items:flex-start; flex-wrap:wrap;">
            <button nxButton="primary small-medium" type="button" (click)="pageNumber=1; getInvoiceList()">Search</button>
            <button nxButton="secondary small-medium" type="button" (click)="exportToExcel()">
              <nx-icon name="file-spreadsheet" class="nx-margin-right-2xs"></nx-icon>Export
            </button>
            <button nxButton="secondary small-medium" type="button" (click)="openUploadModal()">
              <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>New Invoice
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Commission Table -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12">
      <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)" class="nx-margin-top-s">
        <thead style="text-align: center">
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="invoiceMonth">Invoice Period</th>
            <th nxHeaderCell nxSortHeaderCell="submittedOn">Submitted On</th>
            <th nxHeaderCell nxSortHeaderCell="comments">Comments</th>
            <th nxHeaderCell nxSortHeaderCell="paymentDate">Payment Date</th>
            <th nxHeaderCell nxSortHeaderCell="paymentRemarks">Payment Remarks</th>
            <th nxHeaderCell nxSortHeaderCell="status">Status</th>
            <th nxHeaderCell>Actions</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let item of invoiceList">
            <td nxTableCell>{{ months[item.invoiceMonth - 1] }} {{ item.invoiceYear }}</td>
            <td nxTableCell>{{ item.submittedOn | date:'dd/MM/yyyy' }}</td>
            <td nxTableCell class="comment-cell">{{ item.comments }}</td>
            <td nxTableCell>{{ item.paymentDate ? (item.paymentDate | date:'dd/MM/yyyy') : '—' }}</td>
            <td nxTableCell class="comment-cell">{{ item.paymentRemarks || '—' }}</td>
            <td nxTableCell>
              <nx-badge [type]="badgeType(item.status)">{{ item.status }}</nx-badge>
            </td>
            <td nxTableCell>
              <nx-context-menu #menu="nxContextMenu">
                <ng-template nxContextMenuContent>
                  <button nxContextMenuItem type="button" (click)="downloadInvoice(item.id, item.referenceNo)">
                    <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>Download Invoice
                  </button>
                  <button nxContextMenuItem type="button"
                    *ngIf="item.status === 'Invoice Rejected' || item.status === 'Invoice Paid'"
                    (click)="openDetailsModal(item)">
                    <nx-icon name="info-circle-o" class="nx-margin-right-2xs"></nx-icon>
                    {{ item.status === 'Invoice Paid' ? 'View Payment Details' : 'View Rejection Reason' }}
                  </button>
                </ng-template>
              </nx-context-menu>
              <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                aria-label="Open menu" nxTooltip="Actions" nxTooltipPosition="top">
                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

<div *ngIf="count == 0" class="nx-margin-top-2xl">
  <div nxRow nxRowJustify="center">
    <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
  </div>
</div>

<div nxRow style="float: right" *ngIf="count > 0">
  <div nxCol="12">
    <nx-pagination [nxCount]="count" [nxPage]="pageNumber" [nxPerPage]="pageSize" nxType="advanced"
      (nxGoPrev)="prevPage()" (nxGoNext)="nextPage()" (nxGoPage)="goToPage($event)"></nx-pagination>
  </div>
</div>

<!-- ===================== Upload Commission Invoice Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="uploadModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Upload Commission Invoice</h3>
        <p nxCopytext="small" class="nx-margin-bottom-s">
          Upload the PDF e-invoice you have raised to AWP. Select the billing month and add a comment.
        </p>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label>Upload Invoice (PDF only) <strong style="color: red">*</strong></nx-label>
        <app-upload [acceptedfiles]="acceptedTypes" (onUploadFinished)="onFileUploaded($event)"></app-upload>
      </div>
    </div>

    <form [formGroup]="uploadForm">
      <div nxRow class="nx-margin-top-s">
        <div nxCol="6">
          <nx-formfield nxLabel="Invoice Month">
            <nx-dropdown formControlName="invoiceMonth" placeholder="Select Month">
              <nx-dropdown-item *ngFor="let month of months" [nxValue]="month">{{ month }}</nx-dropdown-item>
            </nx-dropdown>
            <nx-error *ngIf="uploadForm.get('invoiceMonth').hasError('required') && uploadForm.get('invoiceMonth').touched">
              Please select the invoice month.
            </nx-error>
          </nx-formfield>
        </div>

        <div nxCol="6">
          <nx-formfield nxLabel="Invoice Year">
            <nx-dropdown formControlName="invoiceYear" placeholder="Select Year">
              <nx-dropdown-item *ngFor="let year of years" [nxValue]="year">{{ year }}</nx-dropdown-item>
            </nx-dropdown>
            <nx-error *ngIf="uploadForm.get('invoiceYear').hasError('required') && uploadForm.get('invoiceYear').touched">
              Please select the invoice year.
            </nx-error>
          </nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="12">
          <nx-formfield nxLabel="Comments">
            <textarea nxInput formControlName="comments" rows="3"
              placeholder="e.g. Commission invoice for April 2025 – 42 policies sold"></textarea>
            <nx-error *ngIf="uploadForm.get('comments').hasError('required') && uploadForm.get('comments').touched">
              Please add a comment describing the invoice period.
            </nx-error>
            <nx-error *ngIf="uploadForm.get('comments').hasError('maxlength')">
              Comments cannot exceed 500 characters.
            </nx-error>
          </nx-formfield>
        </div>
      </div>
    </form>

    <div nxRow class="nx-margin-top-s">
      <div nxCol="6">
        <button nxButton="block primary" type="button" [disabled]="submitting || !uploadedFilePath" (click)="submitInvoice()">
          {{ submitting ? 'Submitting...' : 'Submit Invoice' }}
        </button>
      </div>
      <div nxCol="6">
        <button nxButton="block secondary" type="button" (click)="closeUploadModal()">Cancel</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Commission Details Modal (Paid / Rejected) ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="detailsModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">
          {{ selectedInvoice.status === 'Invoice Paid' ? 'Payment Details' : 'Rejection Reason' }}
        </h3>
      </div>
    </div>

    <ng-container *ngIf="selectedInvoice.status === 'Invoice Paid'">
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">UTR / Transaction ID</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.utrNumber || '—' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Payment Date</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.paymentDate | date:'dd/MM/yyyy' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Amount Paid</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.amountPaid | currency:'INR':'symbol':'1.2-2' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs" *ngIf="selectedInvoice.paymentRemarks">
        <div nxCol="5" class="detail-label">Remarks</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.paymentRemarks }}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedInvoice.status === 'Invoice Rejected'">
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Reason for Rejection</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.rejectionReason || '—' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs" *ngIf="selectedInvoice.reviewedOn">
        <div nxCol="5" class="detail-label">Reviewed On</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.reviewedOn | date:'dd/MM/yyyy' }}</div>
      </div>
    </ng-container>

    <div nxRow class="nx-margin-top-m">
      <div nxCol="12">
        <button nxButton="block secondary" type="button" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</nx-modal>
